var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('router-view')], 1), _c('tab-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNavigation,
      expression: "showNavigation"
    }]
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };